import { motion } from "framer-motion";

const easing = [0.22, 1, 0.36, 1];

// Fade + slide-up section reveal
export const Reveal = ({ children, delay = 0, y = 24, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, ease: easing, delay }}
  >
    {children}
  </motion.div>
);

// Masked line-by-line heading reveal. `lines` is an array of strings.
export const MaskedLines = ({ lines, className = "", delay = 0, stagger = 0.12 }) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span key={i} className="line-mask">
        <motion.span
          className="block"
          initial={{ y: "110%" }}
          animate={{ y: 0 }}
          transition={{ duration: 1, ease: easing, delay: delay + i * stagger }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);

// Masked line reveal triggered on scroll into view.
// Driven by a single parent trigger + staggered children (robust vs. flaky
// per-element observers, especially with smooth-scroll libraries).
export const MaskedLinesInView = ({ lines, className = "", stagger = 0.1 }) => {
  const container = {
    hidden: {},
    visible: { transition: { staggerChildren: stagger } },
  };
  const child = {
    hidden: { y: "110%" },
    visible: { y: 0, transition: { duration: 0.9, ease: easing } },
  };
  return (
    <motion.span
      className={className}
      variants={container}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: "-60px" }}
    >
      {lines.map((line, i) => (
        <span key={i} className="line-mask pb-[0.15em] -mb-[0.15em]">
          <motion.span className="block" variants={child}>
            {line}
          </motion.span>
        </span>
      ))}
    </motion.span>
  );
};
